// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "assets_js_modules_bugReport_js") return "./js/chunks/27db24ac9e2b8b3b4c4b.js";
	if (chunkId === "assets_js_modules_footer_js") return "./js/chunks/28dbd15a8f6a0d713a0e.js";
	if (chunkId === "assets_js_modules_homePage_js") return "./js/chunks/3eff904182e5204516b4.js";
	if (chunkId === "assets_js_modules_module_js") return "./js/chunks/18ecbba337d9de4377c2.js";
	if (chunkId === "assets_js_modules_rgpd_js") return "./js/chunks/7ae88f52040676e2da56.js";
	if (chunkId === "assets_js_vendors_cookies-eu-banner_js") return "./js/chunks/42f16acfb177cd97a69e.js";
	// return url for filenames based on template
	return undefined;
};